import React from 'react';
import { X, MessageCircle } from 'lucide-react';

export default function MessageCenter({ isOpen, onClose }) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center p-4">
    <section role="dialog" aria-modal="true" aria-labelledby="messages-title" className="bg-white rounded-2xl p-6 max-w-lg w-full text-[#4a1825] shadow-xl border-t-4 border-[#76263c]">
      <div className="flex justify-between items-center mb-4">
        <h2 id="messages-title" className="text-2xl font-bold font-serif flex items-center"><MessageCircle className="mr-2" />Messages</h2>
        <button type="button" onClick={onClose} aria-label="Close messages"><X /></button>
      </div>
      <p className="font-medium mb-2">Messaging is not available yet.</p>
      <p>Conversations, attachments, voice recordings, and calls are not connected. No messages are sent from this screen.</p>
      <button type="button" onClick={onClose} className="mt-6 px-4 py-2 rounded-xl bg-[#76263c] text-white">Back to dashboard</button>
    </section>
  </div>;
}
